module.exports = __webpack_public_path__ + "media/application/images/2018/my-consumer-accordian@2x-b9a99f25acdc5a27e4d7669026491a7b.png";